type Props = {
  /** Accessible name for screen readers */
  label?: string;
};

/** Centered ring spinner for list/card sections (Droppie orange accent). */
export const ListSectionSpinner = ({ label = "Loading" }: Props) => (
  <div className="flex justify-center py-12" role="status" aria-label={label}>
    <div
      className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-[#FF5726]"
      aria-hidden
    />
  </div>
);
